import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Container
} from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CategoryIcon from '@mui/icons-material/Category';
import Header from '../../components/Header/Header';
import ExpenseList from '../../components/ExpenseList/ExpenseList';
import { useExpense } from '../../context/ExpenseContext';
import './Expenses.scss';

const Expenses = ({ sessionName = null }) => {
  const { expenses, getTotalExpenses, getExpensesByCategory } = useExpense();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const getAverageExpense = () => {
    if (expenses.length === 0) return 0;
    return getTotalExpenses() / expenses.length;
  };

  const getMostUsedCategory = () => {
    const categories = getExpensesByCategory();
    let maxCategory = 'None';
    let maxCount = 0;
    
    Object.entries(categories).forEach(([category, expenseList]) => {
      if (expenseList.length > maxCount) {
        maxCount = expenseList.length;
        maxCategory = category;
      }
    });
    
    return maxCategory;
  };


  return (
    <div className="expenses-page-wrapper">
      <Header />
      <Container maxWidth="lg" className="expenses-page fade-in">
        {/* Hero Section */}
        <Box className="expenses-hero">
          <Typography variant="h2" className="hero-title">
            Miscellaneous Expenses
          </Typography>
          <Typography variant="h6" color="text.secondary" className="hero-subtitle">
            Track and manage your poker-related expenses
          </Typography>
        </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} className="stats-section">
        <Grid item xs={12} sm={6} md={4}>
          <Card className="stat-card">
            <CardContent>
              <Box className="stat-content">
                <ReceiptIcon className="stat-icon" />
                <Box>
                  <Typography variant="h4" className="stat-number">
                    {expenses.length}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Expenses
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <Card className="stat-card highlight">
            <CardContent>
              <Box className="stat-content">
                <Box className="currency-icon">$</Box>
                <Box>
                  <Typography variant="h4" className="stat-number">
                    {formatCurrency(getTotalExpenses()).replace('$', '')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Amount
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <Card className="stat-card">
            <CardContent>
              <Box className="stat-content">
                <TrendingUpIcon className="stat-icon" />
                <Box>
                  <Typography variant="h4" className="stat-number">
                    {formatCurrency(getAverageExpense()).replace('$', '')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Average Expense
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <Card className="stat-card">
            <CardContent>
              <Box className="stat-content">
                <CategoryIcon className="stat-icon" />
                <Box>
                  <Typography variant="h4" className="stat-number category-text">
                    {getMostUsedCategory()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Top Category
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Content */}
      <Box className="content-section">
        <ExpenseList />
      </Box>
    </Container>
    </div>
  );
};

export default Expenses;